module.exports = __webpack_public_path__ + "media/images/countryrect/tn-f7c683aa704e6cb33111b5be7201f203.svg";